const source = 'contrattiVenditaDataTable'

function getAnomalieMethod () {
  const keys = Object.keys(this.filtered.ids).filter((s) => s == source)

  let ids = []
  if(keys.length > 0){
    ids = this.filtered.ids[source].map((el) => el.value)
  }

  if( ids.length == 0 ){
    
    const baseUrl = window.location.origin
    window.open(`${baseUrl}/ask/contratti/vendita/anomalie`, '_blank')
    
  }else{
    
    this.$eventBus.emit('show-dialog-page', {
      page: 'contratti-vendita-anomalie',
      title: 'Anomalie su contratti di vendita',
      data: ids,
      maximize: false,
  
      buttonOk: {
        label: 'Chiudi',
        icon: 'pi pi-times',
        class: 'p-button-text',
        visible: true,
        disabled: false,
      },
  
      buttonCancel: {
        label: '',
        icon: '',
        class: '',
        visible: false,
        disabled: false,
      },
    })
    
  }
}

export default {
  'bindTo': 'this',
  'method': getAnomalieMethod,
}
